<template>
	<div v-if="headingImage" :class="{ subpage: !route.name.startsWith('index') }">
		<div class="hero-image">
			<slot name="heroContent" />
			<div class="hero-content">
				<div v-if="route.name.startsWith('index')" ref="heroLogo" class="hero-logo" />
				<h1 v-else>{{ title }}</h1>
			</div>
			<picture>
				<source
					v-if="headingImage.imagePortraitWebp"
					:srcset="headingImage.imagePortraitWebp"
					type="image/webp"
					media="(max-width: 500px)"
				/>
				<source
					v-if="headingImage.imagePortrait"
					:srcset="headingImage.imagePortrait"
					media="(max-width: 500px)"
				/>
				<source :srcset="headingImage.imageWebp" type="image/webp" />
				<source :srcset="headingImage.image" />
				<img class="slider-image parallax-delay" :src="headingImage.image" :alt="headingImage.imageAlt" />
			</picture>
			<slot name="scrollDown" />
		</div>
	</div>
</template>

<script setup>
import Rellax from 'rellax';
const route = useRoute();

defineProps({
	headingImage: { type: Object, default: () => {} },
	title: { type: String, default: '' },
});

onMounted(() => {
	const speed = -5;
	new Rellax('.slider-image', {
		speed,
		center: false,
		wrapper: null,
		round: true,
		vertical: true,
		horizontal: false,
	});
});
</script>

<style lang="scss" scoped>
.hero-image {
	width: 100%;
	height: 100vh;
	position: relative;
	overflow: hidden;
}

.hero-image img {
	width: 100%;
	height: 120%;
	object-fit: cover;
}

.subpage .hero-image {
	height: 50vh;
}

.hero-image::before {
	content: '';
	z-index: 2;
	position: absolute;
	display: block;
	inset: 0;
	background: rgb(0 0 0 / 40%);
}

.hero-content {
	position: absolute;
	inset: calc(50% - 200px) 0 auto;
	text-align: center;
	z-index: 3;

	.hero-logo {
		width: 600px;
		height: 400px;
		background: url('~/assets/images/logo-bistrofrancis-hero.svg') no-repeat center center;
		background-size: 100%;
		filter: invert(100%) sepia(0%) saturate(928%) hue-rotate(27deg) brightness(114%) contrast(100%);
		margin: 0 auto;
		animation: fade-in 3s ease forwards;
		animation-delay: 0.5s;
		opacity: 0;

		span {
			transition: opacity 1s ease-in-out;
			opacity: 0;
		}
	}
}

.subpage {
	.hero-content {
		inset: auto 0 60px;

		h1 {
			color: #fff;
			display: block;
		}
	}
}

@media (max-width: 880px) {
	.hero-image {
		width: 100%;
		height: 95vh;
	}

	.hero-content {
		inset: calc(50% - 115px) 0 auto;

		.hero-logo {
			width: 340px;
			height: 230px;
			max-width: 94%;
		}
	}

	.subpage .hero-content {
		bottom: 0;
	}
}

@media (max-height: 780px) {
	.hero-content {
		inset: calc(50% - 105px) 0 auto;

		.hero-logo {
			width: 320px;
			height: 210px;
		}
	}
}
</style>
